































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import CommonLayerDrawer from '../canvasWindow/layerDrawer/commonLayerDrawer/commonLayerDrawer.vue';

import * as def from '@/definitions'
import { Const } from '@/const'
import { Design } from '@/model/document2/page/surface/design/design'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';
import { Vector2 } from '@/utilityModels/vector2'
import { Rectangle } from '@/utilityModels/rectangle'
import { ImageHelper } from '@/helper/imageHelper';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";

@Component({
  components: {
    CommonLayerDrawer
  },
})
export default class DesignRenderer extends Vue
{
    @Prop() private design! : Design;
    @Prop({default: 1}) private quality! : number;
    @Prop({default: false}) private isClipLayer! : boolean;

    // サムネイルを生成する
    @Prop({default : false}) private isRenderingThumbnail! : boolean;
    // サムネイル生成のときは、画像はサムネイルを使用する。
    private get useThumbnailImage() { return this.isRenderingThumbnail; }

    private get renderingOnClient(): boolean {
        return UserAgentHelper.isElectron();
    }

    // viewBox幅
    public get viewWidth() : number
    {
        if(this.isRenderingThumbnail)
        {
            // サムネイルを生成する場合は、上下左右に最大塗り足し幅だけ余白を入れる
            return (this.design.width + Const.BLEED_SIZE_MAX * 2) * this.scale;
        }

        var bounds = this.getBounds();
        var isClipLayer = bounds.width > 0 || bounds.height > 0 ? this.isClipLayer : false;
        return isClipLayer ? bounds.width * this.scale : this.design.width * this.scale;
    }

    // viewBox高さ
    public get viewHeight() : number
    {
        if(this.isRenderingThumbnail)
        {
            // サムネイルを生成する場合は、上下左右に最大塗り足し幅だけ余白を入れる
            return (this.design.height + Const.BLEED_SIZE_MAX * 2) * this.scale;
        }

        var bounds = this.getBounds();
        var isClipLayer = bounds.width > 0 || bounds.height > 0 ? this.isClipLayer : false;
        return isClipLayer ? bounds.height * this.scale : this.design.height * this.scale;
    }

    // viewBox
    private get viewBox() : string
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    private get allLayers()
    {
        return this.design.getAllLayers(false);
    }

    private get layerOffsetX()
    {
        if(this.isRenderingThumbnail)
        {
            // サムネイルを生成する場合は、上下左右に最大塗り足し幅だけ余白を入れる
            return Const.BLEED_SIZE_MAX * this.scale;
        }

        var bounds = this.getBounds();
        var isClipLayer = bounds.width > 0 || bounds.height > 0 ? this.isClipLayer : false;
        return isClipLayer ? -bounds.x * this.scale : 0;
    }

    private get layerOffsetY()
    {
        if(this.isRenderingThumbnail)
        {
            // サムネイルを生成する場合は、上下左右に最大塗り足し幅だけ余白を入れる
            return Const.BLEED_SIZE_MAX * this.scale;
        }

        var bounds = this.getBounds();
        var isClipLayer = bounds.width > 0 || bounds.height > 0 ? this.isClipLayer : false;
        return isClipLayer ? -bounds.y * this.scale : 0;
    }

    // 全描画レイヤーの外接矩形を得る
    private getBounds() : Rectangle
    {
        var minX = 0;
        var minY = 0;
        var maxX = 0;
        var maxY = 0;
        var allLayers = this.design.getAllLayers(false);
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            var bounds = layer.getBoundingRect();
            minX = i == 0 ? bounds.x : Math.min(bounds.x, minX);
            minY = i == 0 ? bounds.y : Math.min(bounds.y, minY);
            maxX = i == 0 ? bounds.x + bounds.width : Math.max(bounds.x + bounds.width, maxX);
            maxY = i == 0 ? bounds.y + bounds.height : Math.max(bounds.y + bounds.height, maxY);
        }

        return new Rectangle(minX, minY, maxX - minX, maxY - minY);
    }

    private get scale()
    {
        // 1mm を pixel変換する
        // mm -> pt
        var pt = UnitHelper.convert(1, "mm", "pt");
        // クオリティを乗じてpxに変換する
        return pt * this.quality;
    }

    // SVGImageを取得する
    public getSvgImage() : { image : string , width : number, height : number }
    {
        DebugHelper.trace(this.$refs.svg)
        var base64 = ImageHelper.convertSVGElementToBase64(this.$refs.svg);
        return { image : base64, width : this.viewWidth, height : this.viewHeight };
    }

    public getSvgElement(): SVGElement {
        return this.$refs.svg as SVGElement;
    }
}
